var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-download"},[_c('p',{staticClass:"subheader"},[_vm._v("Вложения")]),_c('IBFileListItem',{staticClass:"file-download__list__item",attrs:{"files":_vm.files,"append-img-url":"/img/icons/download-light.svg"},on:{"click:append":_vm.downloadFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }